import { Controller } from 'stimulus';

// Header actions of a collapsible task-page section sit beside its <details>
// (inside the summary a click would toggle it). Clicking any of them opens the
// section, so what the action adds is visible when its modal saves.
export default class extends Controller {
  open() {
    const section = this.element.closest('.task-section');
    const details = section && section.querySelector('details');
    if (details) details.open = true;
  }
}
